module.exports = __webpack_public_path__ + "img/chadle_adv_10.d390fb8a.png";